import React, { useEffect, useState } from "react";
import { Shirt, Footprints, Layers, Scissors, Wind, Dumbbell } from "lucide-react";
import api from "@/lib/api";
import ProductImg from "@/components/ProductImg";

const ICONS = { tshirts: Shirt, tracks: Footprints, tracksuits: Layers, shorts: Scissors, jackets: Wind, innerwear: Dumbbell };

export default function CategoryTiles({ active, onPick }) {
  const [groups, setGroups] = useState([]);
  useEffect(() => {
    api.get("/catalog/groups").then((r) => setGroups(r.data.groups)).catch(() => {});
  }, []);
  if (!groups.length) return null;
  return (
    <section className="mb-10" data-testid="shop-by-category">
      <h3 className="font-heading text-lg sm:text-xl font-bold text-slate-900 mb-4">Shop by Category</h3>
      <div className="flex sm:grid sm:grid-cols-3 lg:grid-cols-6 gap-3 overflow-x-auto no-scrollbar -mx-4 px-4 sm:mx-0 sm:px-0 snap-x">
        {groups.map((g) => {
          const Icon = ICONS[g.id] || Shirt;
          const on = active === g.id;
          return (
            <button key={g.id} onClick={() => onPick(on ? "" : g.id)} data-testid={`category-tile-${g.id}`}
              className={`group shrink-0 w-36 sm:w-auto snap-start rounded-2xl border bg-white overflow-hidden text-left transition-[border-color,box-shadow] ${on ? "border-slate-900 ring-2 ring-[#FFDA00]" : "border-slate-200 hover:border-slate-400 hover:shadow-md"}`}>
              <div className="relative aspect-[4/3] bg-slate-50">
                {g.image ? (
                  <ProductImg src={g.image} alt={g.label} className="h-full w-full object-contain p-2 group-hover:scale-105 transition-transform duration-500" />
                ) : (
                  <div className="h-full w-full flex items-center justify-center"><Icon className="h-10 w-10 text-slate-300" /></div>
                )}
                <span className="absolute top-2 left-2 h-8 w-8 rounded-lg bg-[#FFDA00] flex items-center justify-center shadow-sm"><Icon className="h-4 w-4 text-slate-900" /></span>
              </div>
              <div className="px-3 py-2.5">
                <div className="text-sm font-semibold text-slate-900 leading-tight">{g.label}</div>
                <div className="text-xs text-slate-400 mt-0.5">{g.count} designs</div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}
